export const LOGO_URL =
  "https://primary.jwwb.nl/public/o/r/n/temp-bkcxxqajnapgmncxuwyd/logo-high-0coj3f.jpg?enable-io=true&enable=upscale&fit=bounds&width=400";

export const LOGO_URL_LARGE =
  "https://primary.jwwb.nl/public/o/r/n/temp-bkcxxqajnapgmncxuwyd/logo-high-0coj3f.jpg?enable-io=true&enable=upscale&fit=bounds&width=1200";
